<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        input-debounce="0"
        :options="options"
        :error="error"
        :loading="loading"
        :disable="loading"
        emit-value
        map-options
        @filter="filterFn"
        option-value="id"
        option-label="display"
    >
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
                <q-item-section>
                    <q-item-label>
                        {{ scope.opt.display }}
                    </q-item-label>
                    <q-item-label caption>{{ scope.opt.obs }}</q-item-label>
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import RoleService from "@/services/RoleService";
const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
let defaultOptions = [];
const error = computed(() => props.errors && props?.errors?.length !== 0);
const loading = ref(false);
const filterFn = (val, update) => {
    update(() => {
        const needle = val.toLowerCase();
        options.value = defaultOptions.filter(
            (v) => v.display.toLowerCase().indexOf(needle) > -1
        );
    });
};
onMounted(async () => {
    loading.value = true;
    defaultOptions = await RoleService.permissionsAll();
    options.value = defaultOptions;
    loading.value = false;
});
</script>
